{
  "version": 1,
  "asset_id": "2815fa62-e9e5-4e55-8143-cb98820d0320",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/2815fa62-e9e5-4e55-8143-cb98820d0320/cert-imo.png",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/2815fa62-e9e5-4e55-8143-cb98820d0320/cert-imo.png",
  "original_filename": "cert-imo.png",
  "size": 88157,
  "content_type": "image/png",
  "created_at": "2026-09-22T12:21:18Z"
}
